import {
    CREATE_USERFORM_WAREHOUSE_STYLE_DETAILS,
    CREATE_WAREHOUSE_STYLE_DETAILS_FAILURE,
    CREATE_WAREHOUSE_STYLE_DETAILS_REQUEST,
    CREATE_WAREHOUSE_STYLE_DETAILS_SUCCESS,
    DELETE_WAREHOUSE_STYLE_DETAILS_FAILURE,
    DELETE_WAREHOUSE_STYLE_DETAILS_REQUEST,
    DELETE_WAREHOUSE_STYLE_DETAILS_SUCCESS,
    FETCH_ALL_PRODUCTS_STOCKS_SUCCESS,
    FETCH_ALL_WAREHOUSE_STYLE_DETAILS_FAILURE,
    FETCH_ALL_WAREHOUSE_STYLE_DETAILS_REQUEST,
    FETCH_ALL_WAREHOUSE_STYLE_DETAILS_SUCCESS,
    FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_FAILURE,
    FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_REQUEST,
    FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_SUCCESS,
    RESET_WAREHOUSE_STYLE_DETAILS_USERFORM,
    UPDATE_WAREHOUSE_STYLE_DETAILS_FAILURE,
    UPDATE_WAREHOUSE_STYLE_DETAILS_REQUEST,
    UPDATE_WAREHOUSE_STYLE_DETAILS_SUCCESS

} from "./warehouseStyleDetails.actionType";



export const WAREHOUSE_STYLE_DETAILS = 'wareHouseStyleDetails';

let initialState = {
    loading: false,
    warehouseStyleDetailsData: [],
    allProductStocksData: [],
    userform: {},
    warehouseStyleDetailsById: [],
    errorMessage: '',
    warehouseDetailPostData: [],
}

export let warehouseStyleDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_WAREHOUSE_STYLE_DETAILS_REQUEST:
        case FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_REQUEST:
        case CREATE_WAREHOUSE_STYLE_DETAILS_REQUEST:
        case UPDATE_WAREHOUSE_STYLE_DETAILS_REQUEST:
        case DELETE_WAREHOUSE_STYLE_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ALL_WAREHOUSE_STYLE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                warehouseStyleDetailsData: updatePayload
            }
        case FETCH_ALL_PRODUCTS_STOCKS_SUCCESS:
            return {
                ...state,
                loading: false,
                allProductStocksData: updatePayload
            }
        case FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload,
                warehouseStyleDetailsById: updatePayload
            }
        case CREATE_USERFORM_WAREHOUSE_STYLE_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }
        case CREATE_WAREHOUSE_STYLE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                warehouseDetailPostData: updatePayload
            }
        case UPDATE_WAREHOUSE_STYLE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case DELETE_WAREHOUSE_STYLE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case FETCH_ALL_WAREHOUSE_STYLE_DETAILS_FAILURE:
        case FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_FAILURE:
        case CREATE_WAREHOUSE_STYLE_DETAILS_FAILURE:
        case UPDATE_WAREHOUSE_STYLE_DETAILS_FAILURE:
        case DELETE_WAREHOUSE_STYLE_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case RESET_WAREHOUSE_STYLE_DETAILS_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {},
            };
        default:
            return state;
    }
}